const initState = {
  flights: {},
  passengers: [],
  phone: "",
  email: "",
  selectedFlight: null,
  passengerListValid: false,
  journeyDetails: {},
  ancillaryServices: {
    baggage: {},
    meals: {},
    seats: {},
    ssrData: null,
    fareQuoteData: null,
    fareQuoteSuccess: false,
  },
};

const flightReducer = (state = initState, action) => {
  switch (action.type) {
    case "CARRIERS_DATA":
      return { ...state, carriers: action.payload.data };

    case "SELECTED_FLIGHT":
      return { ...state, selectedFlight: action.flight };
    case "SAVE_FLIGHT_BOOKING":
      return { ...state, flight_booking: action.payload.data };
    case "SAVE_HOTEL_BOOKING":
      return { ...state, hotel_booking: action.payload.data };

    case "SET_PASSENGERS":
      return { ...state, passengers: action.data };
    case "SET_PASSENGERS_PHONE":
      return { ...state, phone: action.data };
    case "SET_PASSENGERS_FIRST_NAME":
      return { ...state, firstName: action.data };
    case "SET_PASSENGERS_LAST_NAME":
      return { ...state, lastName: action.data };
    case "SET_PASSENGERS_EMAIL":
      return { ...state, email: action.data };
    case "SET_CURRENCY":
      return { ...state, currency: action.currency };
    case "SET_PASSENGERS_LIST_VALID":
      return { ...state, passengerListValid: action.data };
    case "CLEAR_PASSENGERS_LIST":
      return {
        ...state,
        passengerListValid: false,
        passengers: [],
        phone: "",
        email: "",
      };

    case "SET_JOURNEY_DETAILS":
      return { ...state, journeyDetails: action.data };

    case "UPDATE_PASSENGER_BAGGAGE":
      // Use different keys for outbound and return selections
      // If baggageKey is provided, use it as the primary key
      const baggageTargetKey = action.baggageKey || action.passengerId;

      return {
        ...state,
        ancillaryServices: {
          ...state.ancillaryServices,
          baggage: {
            ...state.ancillaryServices.baggage,
            [baggageTargetKey]: action.baggage
              ? {
                  ...action.baggage,
                  FlightType: action.flightType || "outbound",
                }
              : null,
          },
        },
      };

    case "UPDATE_PASSENGER_MEAL":
      // Use different keys for outbound and return selections
      // If mealKey is provided, use it as the primary key
      const mealTargetKey = action.mealKey || action.passengerId;

      return {
        ...state,
        ancillaryServices: {
          ...state.ancillaryServices,
          meals: {
            ...state.ancillaryServices.meals,
            [mealTargetKey]: action.meal
              ? {
                  ...action.meal,
                  FlightType: action.flightType || "outbound",
                }
              : null,
          },
        },
      };

    case "UPDATE_PASSENGER_SEAT":
      return {
        ...state,
        ancillaryServices: {
          ...state.ancillaryServices,
          seats: {
            ...state.ancillaryServices.seats,
            [action.passengerId]: {
              selection: action.seat,
              price: action.price,
            },
          },
        },
      };

    case "SET_SSR_DATA":
      return {
        ...state,
        ancillaryServices: {
          ...state.ancillaryServices,
          ssrData: action.data,
        },
      };

    case "SET_FARE_QUOTE_SUCCESS":
      return {
        ...state,
        ancillaryServices: {
          ...state.ancillaryServices,
          fareQuoteSuccess: action.success,
        },
      };

    case "SET_FARE_QUOTE_DATA":
      return {
        ...state,
        ancillaryServices: {
          ...state.ancillaryServices,
          fareQuoteData: action.data,
        },
      };

    case "CLEAR_ANCILLARY_SERVICES":
      return {
        ...state,
        ancillaryServices: {
          baggage: {},
          meals: {},
          seats: {},
          ssrData: null,
          fareQuoteData: null,
          fareQuoteSuccess: false,
        },
      };

    default:
      return state;
  }
};

export default flightReducer;
